import React, { Component } from 'react';
import FailedSavesMenu from '../../components/top-bar/FailedSavesMenu.jsx';
import s from './HostStyles.module.scss';

const failedPois = [
    { id: 'foo_1', name: 'Hooby Doo' },
    { id: 'foo_13', name: 'Scooby Doo' },
    { id: 'foo_221', name: 'Sweet Potato Pie' },
];
// const failedPois = [{ id: 'foo_1', name: 'Hooby Doo' }]
export default class FailedSavesMenuHost extends Component {
    constructor(props) {
        super(props);
        this.state = { msg: '', showMenu: true };
    }

    onSelectPoi = id => {
        this.setState({ msg: `Poi Id: ${id || ' nothing'} was clicked`, showMenu: false });
    };

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <div style={{ height: '300px', width: '400px', border: '1px green dotted', position: 'relative' }}>
                    {this.state.showMenu && <FailedSavesMenu failedPois={failedPois} onSelectPoi={this.onSelectPoi} />}
                </div>
                <div>{this.state.msg}</div>
                <button type="button" onClick={() => this.setState({ showMenu: true })}>
                    Show Menu
                </button>
            </div>
        );
    }
}
